import React, { FunctionComponent, ReactNode } from 'react';
import { classNames } from '../../utils/class-names';

interface CardSectionProps {
  className?: string;
  children?: ReactNode;
}

/** Tailwind replacement for the react-bootstrap Card container. */
const Card: FunctionComponent<CardSectionProps> & {
  Body: FunctionComponent<CardSectionProps>;
} = ({ className, children }) => (
  <div
    className={classNames('bg-white border border-gray-200 rounded-lg shadow-xs', className || '')}
  >
    {children}
  </div>
);

const CardBody: FunctionComponent<CardSectionProps> = ({ className, children }) => (
  <div className={classNames('p-5', className || '')}>{children}</div>
);

Card.Body = CardBody;

export default Card;
